/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Col_ApproverInputs */

const vi_stocktake_col_approver = /** @type {(inputs: Stocktake_Col_ApproverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người duyệt`)
};

/**

* @param {Stocktake_Col_ApproverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_col_approver = /** @type {((inputs?: Stocktake_Col_ApproverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Col_ApproverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_col_approver(inputs)
});